module.exports = __webpack_public_path__ + "img/layout.28f0f50f.jpg";